module.exports = __webpack_public_path__ + "static/media/motivating-oneself.1bcbc0c2.svg";